export default "__VITE_ASSET__6cb0872d__"